import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { couriersActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";

const CouriersList = (props) => {
  const { searchQuery } = props;
  const dispatch = useDispatch();
  const couriers = useSelector((state) => state.couriers);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },

    {
      field: "name",
      headerName: "Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "tracking_url",
      headerName: "Tracking Url",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "created_at",
      headerName: "Created At",
      width: 150,
      hide: true,
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 150,
      hide: true,
    },
  ];

  const recordIdentifier = "name";

  useEffect(() => {
    dispatch(couriersActions.getAllParameters());
  }, [dispatch]);

  return (
    <Box>
      {couriers && (
        <DataTable
          loading={couriers?.loading}
          rows={couriers?.items?.data}
          columns={columns}
          recordIdentifier={recordIdentifier}
          actionIdentifier="couriersActions"
          search ={searchQuery}
        />
      )}
    </Box>
  );
};

export default CouriersList;
